<template>
  <b-form-group
    :id="id + 'group'"
    :label="computedLabel"
    :label-for="id"
    :label-sr-only="labelSrOnly"
    class="mb-0"
  >
    <b-form-select
      :id="id"
      v-model="model.$model"
      class="form-control form-control-solid px-6 h-auto"
      :class="{'py-3' : computedSlim, 'py-4' : !computedSlim }"
      :aria-describedby="'feedback-' + id"
      :state="validateState()"
      :disabled="computedDisabled"
    >
      <b-form-select-option
        v-if="showPlaceholder =='1'"
        value="null"
      >
        {{ placeholder }}
      </b-form-select-option>
      <template v-for="(option, i) in options">
        <b-form-select-option
          :key="i"
          :value="option[computedValue]"
        >
          {{ option[optionLabel] }}
        </b-form-select-option>
      </template>
    </b-form-select>
    <b-form-invalid-feedback
      :id="'feedback-' + id"
      v-if="displayError"
    >
      {{ error }}
    </b-form-invalid-feedback>
    <b-form-text
    v-if="helper != undefined"
    class="px-5 py-1"
    :id="'helper-' + id"
    >
      {{ helper }}
    </b-form-text>
  </b-form-group>
</template>

<script>
export default {
  name: "GenericDropdown",

  props: [
    'id',
    'label',
    'model',
    'labelDisplay',
    'options',
    'optionLabel',
    'value',
    'placeholder',
    'errorMessage',
    'showPlaceholder',
    'helper',
    'disabled',
    'slim'
  ],

  methods: {
    validateState() {
      const { $dirty, $error } = this.model;
      return $dirty ? !$error : null;
    }
  },

  computed: {
    labelSrOnly: function() {
      if (this.labelDisplay != undefined) {
        if (this.labelDisplay == "1") {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    displayError: function() {
      if (this.errorMessage != undefined) {
        if (this.errorMessage == "1") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    computedLabel: function() {
      if (this.model.$params.hasOwnProperty('required')) {
        return this.label + "*";
      } else {
        return this.label;
      }
    },
    computedValue: function() {
      if (this.value != undefined) {
        return this.value;
      } else {
        return 'id';
      }
    },
    computedDisabled: function() {
      if (this.disabled != undefined) {
        return this.disabled;
      } else {
        return false
      }
    },
    computedSlim: function() {
      if (this.slim != undefined) {
        return this.slim;
      } else {
        return false;
      }
    }
  }
};
</script>